import { useUpdateResultsMutation } from '~/pages/competition/result/manage/mutations';
import { useCompetitionResultQuery } from '~/pages/competition/result/manage/queries';
import { ResultRecordInfoTable } from './components/result-record-info-table';
import { ResultRecordForm } from './components/result-record-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/result-record-form.schema';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);
  const navigate = useNavigate();

  const { data: result, isLoading } = useCompetitionResultQuery(id);
  const mutation = useUpdateResultsMutation();

  async function onSubmit(payload: Schema) {
    if (!result) return;

    await toast.promise(
      mutation.mutateAsync({
        id,
        payload: {
          national_record_status: payload.national_record_status,
          district_record_status: payload.district_record_status,
        },
      }),
      {
        success: 'Rekordstatus har uppdaterats',
        pending: 'Uppdaterar rekordstatus...',
      }
    );

    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Redigera rekordstatus" />
      </PageLayout.Header>
      <PageLayout.Section>
        <ResultRecordInfoTable result={result} isLoading={isLoading} />
      </PageLayout.Section>
      <PageLayout.Section>
        {result && (
          <ResultRecordForm
            defaultValues={{
              national_record_status: result.national_record_status ?? 'default',
              district_record_status: result.district_record_status ?? 'default',
            }}
            isLoading={mutation.isPending}
            onSubmit={onSubmit}
          />
        )}
      </PageLayout.Section>
    </Fragment>
  );
});
